import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/me.jpg'


const _withScopeId = n => (_pushScopeId("data-v-aafa8e1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "categories" }
const _hoisted_3 = { class: "about-me" }
const _hoisted_4 = { id: "image-of-me" }
const _hoisted_5 = ["alt"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "social-media-section" }
const _hoisted_9 = { class: "information" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "rectangle" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0",
    y: "0",
    fill: "none",
    width: "100%",
    height: "100%"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialMedia = _resolveComponent("SocialMedia")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Quote = _resolveComponent("Quote")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["header-bg", { rotated: _ctx.headerRotation }])
      }, null, 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("development")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("illustration")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("design")), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("figure", _hoisted_4, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: _ctx.$t('my-photo-alt')
        }, null, 8, _hoisted_5),
        _createElementVNode("figcaption", null, _toDisplayString(_ctx.$t("That's me")), 1)
      ]),
      _createElementVNode("article", null, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("intro1")) + " ", 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("intro2")), 1),
          _createTextVNode(_toDisplayString(_ctx.$t("intro3")), 1)
        ]),
        _hoisted_6,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("intro4")), 1),
        _hoisted_7,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("intro5")), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMedias, (socialMedia) => {
        return (_openBlock(), _createElementBlock("div", {
          key: socialMedia.id
        }, [
          _createVNode(_component_SocialMedia, {
            "fa-icon": socialMedia.faIcon,
            url: socialMedia.url,
            text: socialMedia.text,
            id: socialMedia.id
          }, null, 8, ["fa-icon", "url", "text", "id"])
        ]))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.information, (info, i) => {
        return (_openBlock(), _createElementBlock("div", { key: i }, [
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              src: 
              _ctx.getImgUrl(
                info.src,
                info.src === 'motion_graphics' ? 'gif' : 'jpg'
              )
            ,
              alt: _ctx.$t(info.srcAlt) + ' ' + _ctx.$t(info.title)
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("article", null, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t(info.title)), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t(info.text)), 1),
            _createElementVNode("a", {
              href: info.link,
              role: "button"
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fas fa-chevron-right" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("View more")) + " ", 1),
              _hoisted_12
            ], 8, _hoisted_11)
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_Quote, {
      quote: "quote-paul-rand",
      author: "Paul Rand"
    })
  ]))
}